// extracted by mini-css-extract-plugin
module.exports = {"footer":"Offers_footer__QPejc"};